export default __webpack_public_path__ + "static/media/portfolio-smiles-4.e26db21f.jpg";